var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Dexie from 'dexie';
// 데이터베이스 클래스 정의
var AppDB = /** @class */ (function (_super) {
    __extends(AppDB, _super);
    function AppDB() {
        var _this = _super.call(this, 'AppDB') || this;
        // 버전 및 스키마 정의
        _this.version(1).stores({
            KeyValueStore: 'key' // Primary Key는 'key'
        });
        return _this;
    }
    return AppDB;
}(Dexie));
// 데이터베이스 인스턴스 생성
export var db = new AppDB();
